function MessageIcon() {
  return (
    <svg width={17} height={17} fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="prefix__message"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={1}
        width={15}
        height={15}
      >
        <path
          d="M14.79 2.319a1.289 1.289 0 00-1.287-.336L2.772 5.104a1.28 1.28 0 00-.922 1.014c-.095.5.236 1.136.668 1.402l3.355 2.062a.87.87 0 001.073-.129l3.843-3.866a.49.49 0 01.707 0 .509.509 0 010 .712l-3.85 3.866a.882.882 0 00-.128 1.08l2.05 3.389c.24.402.654.63 1.107.63.054 0 .114 0 .167-.006a1.3 1.3 0 001.087-.926L15.11 3.614a1.31 1.31 0 00-.32-1.295"
          fill="#fff"
        />
      </mask>
      <g mask="url(#prefix__message)">
        <path fill="#fff" fillOpacity={0.6} d="M.5.557h16v16H.5z" />
      </g>
    </svg>
  );
}

export default MessageIcon;
